import { createDownloadReportQuery } from '@utils/reports'
import StoreTags from '@enums/StoreTags'
import emptySplitApi from '../api'

const BASE_URL = '/api/probation_sheets'

export const probationSheetsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getProbationSheetEmployeeReport: builder.mutation<void, string | number>({
      query: (id) =>
        createDownloadReportQuery({
          url: `${BASE_URL}/${id}/employee_report`,
          method: 'POST',
        })({}),
      invalidatesTags: [StoreTags.REPORTS],
    }),
  }),
})

export const { useGetProbationSheetEmployeeReportMutation } = probationSheetsApi
